<template>
  <!--Mobile app system-->
  <div class="app-section">
    <ul class="mobile-app d-flex justify-content-between align-items-center">
      <!-- <li>
        <a href="javascript:;" class="d-flex align-items-center click-heretwo">
          <span class="icon"
            ><img src="@/assets/img/header/referal.png" alt="referral"
          /></span>
          <span>Referral</span>
        </a>
      </li> -->
      <li class="main-baricon">
        <div class="dashboard-active">
          <i class="fas fa-bars"></i>
        </div>
      </li>
      <li>
        <a href="#" class="search-icon Click-here">
          <img src="@/assets/img/header/search.png" alt="search-img" />
        </a>
      </li>
      <li>
        <label class="theme-switch-container">
          <span class="theme-switch-label">
            <span class="light-label d-flex align-items-center" v-if="theme == 'light'">
              <i class="fas fa-sun"></i>
            </span>
            <span class="dark-label text-white d-flex align-items-center" v-if="theme == 'dark'">
              <i class="fas fa-moon"></i>
            </span>
          </span>
          <input type="checkbox" class="theme-switcher" @change="toggleTheme" />
          <div class="slider round"></div>
        </label>
      </li>
      <!-- <li>
        <a href="javascript:;" class="Click-here"> free </a>
      </li> -->
    </ul>
  </div>
  <!--Mobile app system-->
</template>

<script>
import { useHomeStore } from "@/store/home";
import { mapActions, mapState } from "pinia";

export default {
  name: "MobileNav",
  computed: {
    ...mapState(useHomeStore, ["theme"]),
  },
  methods: {
    ...mapActions(useHomeStore, ["toggleTheme", "loadTheme"]),
  },
  mounted() {
    this.loadTheme()
  },
};
</script>
